import { Box, Divider, Stack } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";
import { Loader, LoadingButton, NewFormCardWrapper } from "../../../shared";
import { useLoyaltyConfig, useTaxingConfig } from "../hooks";
import { TenantInfoText } from "../components";

export const OthersConfig = () => {
  const loyalty = useLoyaltyConfig();
  const taxing = useTaxingConfig();

  const loyaltyValidation = loyalty.formValidator.current.message(
    "Loyalty Term",
    loyalty.state.formData.loyalty_term,
    "required",
  );
  const taxingValidations = {
    tax_id_term: taxing.formValidator.current.message(
      "Business Tax Identifier Term",
      taxing.state.formData.tax_id_term,
      "required",
    ),
    tax_term: taxing.formValidator.current.message(
      "Sales Tax Term",
      taxing.state.formData.tax_term,
      "required",
    ),
  };

  return (
    <Stack gap="16px">
      <NewFormCardWrapper title="Loyalty">
        {loyalty.state.isLoading ? (
          <Stack height="151.91px" justifyContent="center" alignItems="center">
            <Loader />
          </Stack>
        ) : (
          <Stack gap="20px">
            <Box>
              <InputControl
                name="loyalty_term"
                label="Loyalty Term"
                placeholder="Loyalty"
                value={loyalty.state.formData.loyalty_term}
                onChange={loyalty.onChange}
                error={!!loyaltyValidation}
                helperText={loyaltyValidation}
              />
              <TenantInfoText infoKey="loyaltyTerm" />
            </Box>
            <Divider />
            <LoadingButton
              variant="contained"
              sx={{ ml: "auto", width: { xs: "100%", sm: "max-content" } }}
              onClick={loyalty.onSubmit}
              loading={loyalty.state.isSubmitting}
              disabled={!loyalty.state.hasChanges}
            >
              Save
            </LoadingButton>
          </Stack>
        )}
      </NewFormCardWrapper>

      <NewFormCardWrapper title="Taxing">
        {taxing.state.isLoading ? (
          <Stack height="151.91px" justifyContent="center" alignItems="center">
            <Loader />
          </Stack>
        ) : (
          <Stack gap="20px">
            <Stack flexDirection="row" gap="12px">
              <Box width="100%">
                <InputControl
                  name="tax_id_term"
                  label="Business Tax Identifier Term"
                  placeholder="TAX ID"
                  value={taxing.state.formData.tax_id_term}
                  onChange={taxing.onChange}
                  error={!!taxingValidations.tax_id_term}
                  helperText={taxingValidations.tax_id_term}
                  fullWidth
                />
                <TenantInfoText infoKey="taxIdTerm" />
              </Box>
              <Box width="100%">
                <InputControl
                  name="tax_term"
                  label="Sales Tax Term"
                  placeholder="VAT"
                  value={taxing.state.formData.tax_term}
                  onChange={taxing.onChange}
                  error={!!taxingValidations.tax_term}
                  helperText={taxingValidations.tax_term}
                  fullWidth
                />
                <TenantInfoText infoKey="taxTerm" />
              </Box>
            </Stack>

            <Divider />
            <LoadingButton
              variant="contained"
              sx={{ ml: "auto", width: { xs: "100%", sm: "max-content" } }}
              onClick={taxing.onSubmit}
              loading={taxing.state.isSubmitting}
              disabled={!taxing.state.hasChanges}
            >
              Save
            </LoadingButton>
          </Stack>
        )}
      </NewFormCardWrapper>
    </Stack>
  );
};
